import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textSObj } = typographyStyles;

const neutral500 = colors.ui.neutral[500];
const neutral600 = colors.ui.neutral[600];

export const buttonCss: CSSObject = {
  borderRadius: "12px",
  color: neutral600,
  display: "flex",
  margin: "10px 0",
  padding: "16px 19px",

  ":hover": {
    textDecoration: "underline",
  },
};

export const buttonLabelCss: CSSObject = {
  ...textSObj,
  alignItems: "flex-start",
  display: "flex",
  gap: "16px",
  width: "100%",
};

export const editIconCss: CSSObject = {
  height: "24px",
  width: "24px",
  marginTop: "-2px",

  path: {
    stroke: neutral600,
    strokeWidth: "2px",
  },
};

export const externalLinkIconCss: CSSObject = {
  height: "24px",
  width: "24px",

  path: {
    fill: neutral500,
    stroke: neutral500,
    strokeWidth: "1px",
  },
};
